import { type AuthConfig, Role } from '@kitopi-com/auth';
import { DASHBOARD_URL } from 'utils/constants';

export const authConfig: AuthConfig = {
  enableErrorLog: true,
  ssoOrigin: DASHBOARD_URL,
  allowedRoles: [Role.SALESFORCE_AGENT],
  redirectToSignInOnFail: false,
};
